import { useQuery } from "@tanstack/react-query";
import { ApiError, api } from "./api";
import { awaitsReview, connectorKeys } from "./connectors";

// One Boo's connectors, those waiting on a person first. Empty without a Boo
// (org settings) and on a backend from before connectors (404).
export function useConnectors(containerId?: string) {
  const query = useQuery({
    queryKey: connectorKeys.list(containerId ?? ""),
    queryFn: () => api.connectors.list(containerId!),
    enabled: !!containerId,
  });
  const connectors = [...(query.data?.connectors ?? [])].sort((a, b) => Number(awaitsReview(b)) - Number(awaitsReview(a)));
  const error = query.isError && !(query.error instanceof ApiError && query.error.status === 404) ? query.error : null;
  return { connectors, waitingCount: connectors.filter(awaitsReview).length, error };
}
